<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="actualizado()">
        <div class="card">
            <div v-if="!entrada.butaca && !entrada.numero" class="card-header bg-secondary">
                {{ entrada.asiento.zona_nombre ?? entrada.zona_nombre }} <br>
                <span v-if="entrada.asiento.fila && entrada.asiento.asiento">Fila: {{ entrada.asiento.fila }} / Butaca: {{ entrada.asiento.asiento }}</span>
                <span v-else>Sin numerar</span>
            </div>
            <div v-else-if="entrada.butaca" class="card-header bg-secondary">
                <span>Sector: {{ entrada.nombre_sector ?? entrada.sector_name }}</span> <br>
                <span>Fila: {{ entrada.fila }} / Butaca: {{ entrada.butaca }}</span>
            </div>
            <div v-else-if="entrada.numero" class="card-header bg-secondary">
                <span>Plaza: {{ entrada.numero }}</span>
            </div>
            <div class="card-body">
                <template v-if="solicitar_datos">
                    <FormInput id="nombre" label="Nombre" name="Nombre" v-model="entrada.nombre" @change="actualizado" />
                    <FormInput id="apellidos" label="Apellidos" name="Apellidos" v-model="entrada.apellidos" @change="actualizado" />
                    <FormInput id="dni" label="DNI" name="DNI" v-model="entrada.dni" @change="actualizado" />
                </template>
                
                <div class="form-group">
                    <label for="precio">Precio</label>
                    <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                        <select class="form-control" id="select-precio" v-model="entrada.precio" v-on:change="actualizado">
                            <template v-for="(precio, index) in entrada.precios">
                                <option v-if="!entrada.butaca && !entrada.numero" :key="index" :value="precio">{{ precio.description ?? precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                                <option v-else :key="index" :value="precio">{{ precio.description ?? precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                            </template>
                        </select>
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group" v-if="teatro.solicitar_genero_taquilla">
                    <label for="genero">Género</label>
                    <select class="form-control" id="select-genero" v-model="entrada.genero_id" v-on:change="actualizado">
                        <template v-for="genero in generos">
                            <option :key="genero.id" :value="genero.id">{{ genero.name }}</option>
                        </template>
                    </select>
                </div>
                <div class="form-group" v-if="permisos['venta.descuento']">
                    <label for="descuento">Descuento</label>
                    <select v-model="entrada.descuento" class="form-control" id="select-descuento" v-on:change="actualizado">
                        <option value="0">Sin descuento</option>
                        <template v-for="(descuento, index) in configuracion.descuentos_disponibles">
                            <option :key="index" :value="descuento">{{ descuento }}%</option>
                        </template>
                    </select>
                </div>
                <template v-if="fields && fields.length > 0">
                    <div v-for="(field, fieldIndex) in fields" :key="fieldIndex" class="form-group">
                        <FieldComponent 
                            :field="field"
                            :entradaIndex="index"
                            :fieldIndex="fieldIndex"
                            v-model="entrada.properties[field.name]"
                            v-on:input="actualizado"
                        />
                    </div>
                </template>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import FieldComponent from '@/components/common/FieldComponent';

export default {
    props: ['entrada', 'generos', 'index', 'solicitar_datos', 'fields'],
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    created() {
        if (this.fields && this.fields.length > 0) {
            if (!this.entrada.properties) {
                this.entrada.properties = {};
                this.fields.forEach(field => {
                    this.entrada.properties[field.name] = null;
                });
            }
        }

        if(this.entrada.precios.length === 1){
            this.entrada.precio = this.entrada.precios[0]
        }

        var hash_teatro = this.configuracion.hash_teatro;
        if(hash_teatro === 'jPrFr1rSNcqbXShv50cb' || hash_teatro === 'YPY8EVtyoYMWay0EHAmN' || hash_teatro === 'UmeRCe3vusTW1LYct845') {
            var descuentos = [
                'JÓVENES ENTRE 14 Y 25 AÑOS - 15',
                'MAYORES DE 65 AÑOS - 15',
                'DESEMPLEADOS - 15',
                'FAMILIAS NUMEROSAS - 15',
                'ESTUDIANTES CONSERVATORIO DANZA - 15',
                'ESTUDIANTES CONSERVATORIO MÚSICA - 15',
                'GRUPOS DE 15 O MÁS - 15',
                'ESCUELA SUPERIOR ARTE DRAMÁTICO - 15',
                'UNIVERSITARIOS - 15',
                'MURCIA TOURIST CARD - 15',
                'ERASMUS STUDENTS CARD - 15',
                'ASOC. ACTORES DE LA REGIÓN DE MURCIA - 15',
                'ASOC. PROFESIONALES CIRCO REGIÓN MURCIA - 15',
                'ASOC.DRAMATURGOS REGIÓN MURCIA - 15',
                'ASOCIACIÓN MURCIA ESCENA - 15',
                'ASOC. DIRECTORES REGIÓN DE MURCIA - 15',
                'ASOCIACIÓN PLATAFORMA 44 - 15',
                'ASOCIACIÓN FATEAMUR - 15',
                'UNIDADES FAMILIARES MONOPARENTALES - 15',
            ]

            this.configuracion.descuentos_disponibles = descuentos.concat(this.configuracion.descuentos_disponibles);
        }
        
    },
    methods: {
        actualizado(field, checkboxError) {
            this.$emit('actualizado', checkboxError, this.entrada.properties);
        },
        getPrecio(precio) {
            let price = parseFloat(precio.precio);
            
            if(precio.price_management_interno_taquilla || precio.gd_interno) {
                return price;
            }

            return price + parseFloat(precio.price_management_taquilla);
        }
    },
    components: {
        FieldComponent
    }
}
</script>
